import { ErrorBoundary } from "react-error-boundary";

import ListPageHeader from "app/pages/sales-intelligence/common-components/header/ListPageHeader/ListPageHeader";
import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";
import withSecondaryBarSet from "app/pages/sales-intelligence/hoc/withSecondaryBarSet";
import { StyledManagementCardSurface } from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/styles";
import manageSignalsPageTrackingService from "app/pages/sales-intelligence/pages/manage-signals/services/tracking";
import withSignalsManagement from "app/pages/sales-intelligence/sub-modules/signals/hoc/withSignalsManagement";
import SignalSource from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalSource";

import { AccountSignalsManagementSection } from "./components/AccountSignalsManagementSection/AccountSignalsManagementSection";
import { AccountSignalsPageHeaderActions } from "./components/AccountSignalsPageHeaderActions/AccountSignalsPageHeaderActions";
import { AccountSignalsTypeSections } from "./components/AccountSignalsTypeSections/AccountSignalsTypeSections";
import { PageErrorState } from "./components/ErrorState/PageErrorState";
import { SignalsIntegrationBanner } from "./components/SignalsIntegrationBanner/SignalsIntegrationBanner";
import { useAccountSignalSectionRefs } from "./hooks/useAccountSignalSectionRefs";
import { StyledManageSignalsPageContainer } from "./styles";

const ManageSignalsPageContainer = () => {
    const { registerSectionRef, scrollToSignalType } = useAccountSignalSectionRefs();

    const handleSignalTypeClick = (signalType: SignalType): void => {
        manageSignalsPageTrackingService.trackScrollToSignalTypeSection(signalType);
        scrollToSignalType(signalType);
    };

    return (
        <StyledManageSignalsPageContainer
            gap="20px"
            margin="0 auto 40px"
            width="100%"
            data-automation="manage-signals-page-container"
        >
            <ListPageHeader
                title={{ key: "si.account-signals.management.page.title" }}
                description={{ key: "si.account-signals.management.page.description" }}
            >
                <AccountSignalsPageHeaderActions />
            </ListPageHeader>
            <ErrorBoundary FallbackComponent={PageErrorState}>
                <StyledManagementCardSurface
                    gap="16px"
                    alignItems="flex-start"
                    data-automation="account-signals-management-section-surface"
                >
                    <AccountSignalsManagementSection onSignalTypeClick={handleSignalTypeClick} />
                </StyledManagementCardSurface>
                <SignalsIntegrationBanner />
                <AccountSignalsTypeSections registerSectionRef={registerSectionRef} />
            </ErrorBoundary>
        </StyledManageSignalsPageContainer>
    );
};

export default withSignalsManagement(
    withSecondaryBarSet("SalesIntelligenceIntent")(ManageSignalsPageContainer),
    SignalSource.Account,
);
